module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQMKwV7AIYAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAsUlEQVRIS+3UPQ6DMAwF4LgbZ+AQnTr2Rl27FO6eyn2NbH6cpsbZeJKFkAyfjVDSsVBGdQvl4XHpiQAQJBwSgOt2HRUUhgnCgAbDkTqgN3PB1LAB5dd9+JQDAYAHda1D+TnNHkQDtQBAnzXEbtqBtr5NTuBnTsAMN6Lk/67FtQGOABuQIbjcn8g+Z6xj/e/IlMsXbAG+LnsOZR8IR0ppIBgpAdQRKAHSEeBgm++NIym9AZvf04s2RHlTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/fletching-icon.png
// module id = 492
// module chunks = 0